import { memo, createContext, useMemo, createElement, useState, useRef, useContext, useEffect } from 'react';
import { useCookiesState } from '@r123/ui/dist/hooks/useCookiesState';
import { tailwindHelpers, ReactPortalComponent, DialogWithHeader, Input } from '@r123/ui';
import { useForm } from 'react-hook-form';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

// src/constant.ts
var INVALID_DESTINATION_NUMBER = 3;
var OTP_COOKIE_KEY = "enquiry_data";
var DEFAULT_OTP_COOKIE_VALUE = {
  name: "",
  phoneNumber: "",
  email: "",
  requestId: "",
  requestOTPTime: 0,
  isVerified: false
};
var TRANSLATION = {
  id: {
    // mortgageDataTitle: "Data untuk KPR",
    // name: "Nama",
    // placeHolderName: "Tulis Nama",
    // phoneNumber: "Nomor Telepon",
    placeHolderPhone: "Telepon",
    // monthlyIncomeRange: "Kisaran Penghasilan Bulanan",
    // propertyPriceRange: "Kisaran Harga Properti",
    // propertyLocation: "Lokasi Properti",
    // relatedAreas: "Area Terkait",
    // dataUsage: "Data digunakan agar kamu dapat rekomendasi KPR yang sesuai.",
    // privacyAgreement:
    //   "Saya setuju dengan Kebijakan Privasi Rumah123 serta memberikan otorisasi kepada kami untuk meneruskan data kepada partner bank.",
    // continue: "Ajukan",
    phoneVerification: "Verifikasi Nomor Handphone",
    // enterOTP:
    //   "Silahkan masukan 6 digit kode OTP yang telah kami kirimkan ke nomor 08131378262G",
    changeNumber: "Ganti Nomor",
    // noOTP: "Tidak mendapatkan kode OTP?",
    resend: "Kirim Ulang",
    // completePersonalData: "Lengkapi Data Diri untuk KPR",
    // applyTiming: "Kapan akan mengajukan KPR?",
    // timingOptions: ["Segera", "1 - 3 Bulan", "3 - 6 Bulan", "> 6 Bulan"],
    // desiredProperty: "Sudah ada properti yang diinginkan?",
    // propertyOptions: ["Sudah", "Belum"],
    // occupationType: "Tipe Pekerjaan",
    // occupationOptions: [
    //   "Karyawan",
    //   "Profesional",
    //   "Pegawai Pemerintahan",
    //   "Wiraswasta",
    //   "Pegawai BUMN/BUMD",
    //   "Lainnya",
    // ],
    // employmentLength: "Lama Bekerja",
    // maritalStatus: "Status Perkawinan",
    // maritalOptions: ["Tidak Kawin", "Kawin", "Cerai hidup", "Cerai mati"],
    // submit: "Ajukan",
    // dataSentSuccess: "Data Berhasil Terkirim",
    // dataConfirmation:
    //   "Kami akan terhubung dengan Tim Rumah123 untuk konfirmasi data",
    wrongOTP: "Kode yg Anda masukan salah pastikan kode OTP yang Anda masukan benar"
    // send: "Kirim",
    // searchLocation: "Sedang mencari lokasi",
  },
  en: {
    // mortgageDataTitle: "Mortgage Data",
    // name: "Name",
    // placeHolderName: "Your Name",
    // phoneNumber: "Phone Number",
    placeHolderPhone: "Phone",
    // monthlyIncomeRange: "Monthly Income Range",
    // propertyPriceRange: "Property Price Range",
    // propertyLocation: "Property Location",
    // relatedAreas: "Related Areas",
    // dataUsage:
    //   "This data is used to provide you with suitable mortgage recommendations.",
    // privacyAgreement:
    //   "I agree to the Privacy Policy of Rumah123 and authorize us to share data with partner banks.",
    // continue: "Continue",
    phoneVerification: "Phone Number Verification",
    // enterOTP:
    //   "Please enter the 6-digit OTP (One-Time Password) that we have sent to the number 08131378262G.",
    changeNumber: "Change Number",
    // noOTP: "Didn't receive the OTP?",
    resend: "Resend",
    // completePersonalData: "Complete Personal Data for Mortgage",
    // applyTiming: "When do you plan to apply for a mortgage?",
    // timingOptions: [
    //   "Immediately",
    //   "1 - 3 months",
    //   "3 - 6 months",
    //   "> 6 months",
    // ],
    // desiredProperty: "Do you already have a desired property?",
    // propertyOptions: ["Yes", "No"],
    // occupationType: "Occupation Type",
    // occupationOptions: [
    //   "Employee",
    //   "Professional",
    //   "Government Employee",
    //   "Entrepreneur",
    //   "BUMN/BUMD Employee",
    //   "Other",
    // ],
    // employmentLength: "Length of Employment",
    // maritalStatus: "Marital Status",
    // maritalOptions: [
    //   "Single",
    //   "Married",
    //   "Separated (living apart)",
    //   "Widowed",
    // ],
    // submit: "Submit",
    // dataSentSuccess: "The data has been successfully sent",
    // dataConfirmation:
    //   "You will be connected with the Rumah123 team for data confirmation",
    wrongOTP: "The code inserted does not match the expected value"
    // send: "Send",
    // searchLocation: "Searching for location",
  }
};
var phoneNumbers = [
  {
    label: "Indonesia",
    value: "+62"
  },
  {
    label: "Algeria",
    value: "+213"
  },
  {
    label: "Argentina",
    value: "+54"
  },
  {
    label: "Australia",
    value: "+61"
  },
  {
    label: "Bahrain",
    value: "+973"
  },
  {
    label: "Bangladesh",
    value: "+880"
  },
  {
    label: "Brazil",
    value: "+55"
  },
  {
    label: "Cambodia",
    value: "+855"
  },
  {
    label: "Canada",
    value: "+1"
  },
  {
    label: "China",
    value: "+86"
  },
  {
    label: "Egypt",
    value: "+20"
  },
  {
    label: "Guinea",
    value: "+224"
  },
  {
    label: "India",
    value: "+91"
  },
  {
    label: "Iraq",
    value: "+964"
  },
  {
    label: "Jamaica",
    value: "+1 876"
  },
  {
    label: "Japan",
    value: "+81"
  },
  {
    label: "Jordan",
    value: "+962"
  },
  {
    label: "Kenya",
    value: "+254"
  },
  {
    label: "Kuwait",
    value: "+965"
  },
  {
    label: "Lebanon",
    value: "+961"
  },
  {
    label: "Malaysia",
    value: "+60"
  },
  {
    label: "Maldives",
    value: "+960"
  },
  {
    label: "Mexico",
    value: "+52"
  },
  {
    label: "Morocco",
    value: "+212"
  },
  {
    label: "Nigeria",
    value: "+234"
  },
  {
    label: "Pakistan",
    value: "+92"
  },
  {
    label: "Panama",
    value: "+507"
  },
  {
    label: "Papua New Guinea",
    value: "+675"
  },
  {
    label: "Philippines",
    value: "+63"
  },
  {
    label: "Qatar",
    value: "+974"
  },
  {
    label: "Saudi Arabia",
    value: "+966"
  },
  {
    label: "Senegal",
    value: "+221"
  },
  {
    label: "Singapore",
    value: "+65"
  },
  {
    label: "South Africa",
    value: "+27"
  },
  {
    label: "Thailand",
    value: "+66"
  },
  {
    label: "Turkey",
    value: "+90"
  },
  {
    label: "United Arab Emirates",
    value: "+971"
  },
  {
    label: "United States",
    value: "+1"
  },
  {
    label: "Brunei Darussalam",
    value: "+673"
  },
  {
    label: "Hong Kong",
    value: "+852"
  },
  {
    label: "Iran, Islamic Republic of",
    value: "+98"
  },
  {
    label: "Macao",
    value: "+853"
  },
  {
    label: "Taiwan, Province of China",
    value: "+886"
  },
  {
    label: "Timor-Leste",
    value: "+670"
  },
  {
    label: "Viet Nam",
    value: "+84"
  }
];

// ../graphql-codegen/dist/index.mjs
var EnumTypeOtp = /* @__PURE__ */ ((EnumTypeOtp2) => {
  EnumTypeOtp2["Sms"] = "SMS";
  EnumTypeOtp2["Whatsapp"] = "WHATSAPP";
  return EnumTypeOtp2;
})(EnumTypeOtp || {});
var OTP_NUMBER_LENGTH = 6;
var FormOtp = ({
  onChangePhoneNumber,
  onResend,
  onResetError,
  onSubmit,
  errorOtp,
  phoneNumber,
  resendTimeout,
  language = "id"
}) => {
  const { register, getValues, setValue } = useForm();
  const handleInput = (event) => {
    event.preventDefault();
    const {
      target: { name, value }
    } = event;
    const values = getValues();
    const otpCodes = Object.values({
      ...values,
      [name]: value
    }).join("");
    if (otpCodes.length === OTP_NUMBER_LENGTH) {
      onSubmit(otpCodes);
      return;
    } else {
      onResetError();
    }
    if (event.target.value.length && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      return;
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Backspace" && !event.target.value) {
      event.target.previousElementSibling?.focus();
    }
  };
  const handlePaste = (event) => {
    event.preventDefault();
    const text = event.clipboardData.getData("text/plain");
    text.split("").forEach((char, index) => {
      setValue(String(index), char);
    });
    if (OTP_NUMBER_LENGTH === text.length) {
      onSubmit(Object.values({ ...text }).join(""));
    }
  };
  const renderTimeout = (timeout) => {
    if (!timeout)
      return `00`;
    if (timeout < 10)
      return `0${timeout}`;
    return timeout;
  };
  const renderNumber = useMemo(() => {
    return Array.from(Array(OTP_NUMBER_LENGTH).keys()).map((index) => {
      return /* @__PURE__ */ createElement(
        "input",
        {
          ...register(String(index)),
          key: `otp-num-${index}`,
          inputMode: "numeric",
          onInput: handleInput,
          onKeyDown: handleKeyDown,
          onPaste: handlePaste,
          pattern: "\\d*",
          type: "number",
          autoComplete: "off",
          autoFocus: index === 0,
          className: tailwindHelpers.cn(
            "r123-otp-input",
            "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            {
              "border-0 border-b-2 border-solid text-center w-8 md:w-10 focus-visible:outline-none": true,
              "text-2xl text-primary": true,
              "border-b-neutral30": !errorOtp,
              "border-b-errorAlert": errorOtp
            }
          )
        }
      );
    });
  }, [handleInput, handleKeyDown, handlePaste]);
  return /* @__PURE__ */ jsxs("form", { className: "max-w-enquiry mx-auto", noValidate: true, children: [
    /* @__PURE__ */ jsxs("p", { className: "font-normal my-4 text-xs", children: [
      language === "id" && /* @__PURE__ */ jsxs(Fragment, { children: [
        "Silahkan masukan ",
        OTP_NUMBER_LENGTH,
        " digit kode OTP yang telah kami kirimkan ke nomor ",
        phoneNumber
      ] }),
      language === "en" && /* @__PURE__ */ jsxs(Fragment, { children: [
        "Please enter the ",
        OTP_NUMBER_LENGTH,
        "-digit OTP (One-Time Password) that we have sent to the number ",
        phoneNumber
      ] }),
      /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "p-0 px-1 bg-transparent outline-none border-none underline inline-flex text-primary cursor-pointer",
          onClick: onChangePhoneNumber,
          children: TRANSLATION[language].changeNumber
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex justify-center mt-4 mx-0 mb-6 gap-4", children: renderNumber }),
    errorOtp && /* @__PURE__ */ jsx("div", { className: "text-errorAlert text-xs font-normal mb-6", children: TRANSLATION[language].wrongOTP }),
    Boolean(resendTimeout) ? /* @__PURE__ */ jsxs("p", { className: "text-xs mb-4 text-center", children: [
      TRANSLATION[language].resend,
      " OTP? (00:",
      renderTimeout(resendTimeout),
      ")"
    ] }) : /* @__PURE__ */ jsxs("div", { className: "text-xs mb-4 text-center", children: [
      /* @__PURE__ */ jsx("p", { className: "m-0 mb-3", children: "Tidak mendapatkan Kode OTP?" }),
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          className: "m-auto p-0 px-2 underline text-xs bg-white text-primary flex items-center gap-x-1 outline-none border-none cursor-pointer",
          title: `${TRANSLATION[language].resend} ${resendTimeout ? resendTimeout : ""}`,
          disabled: Boolean(resendTimeout),
          onClick: onResend,
          children: [
            /* @__PURE__ */ jsx(
              "svg",
              {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M13.1997 7.98909C13.1997 7.25434 13.0551 6.55086 12.7659 5.87864C12.4767 5.20643 12.0898 4.62801 11.6051 4.14339C11.1205 3.65877 10.5421 3.27185 9.86989 2.98264C9.19768 2.69343 8.49419 2.54883 7.75945 2.54883C6.8371 2.54883 5.97534 2.76769 5.17415 3.20541C4.37296 3.64313 3.72029 4.24109 3.21613 4.99929C2.71196 5.75749 2.4208 6.59776 2.34264 7.5201L1.79158 6.44143C1.76031 6.37108 1.7095 6.32223 1.63915 6.29487C1.56881 6.26751 1.49846 6.27337 1.42811 6.31246L1.33431 6.34763C1.26396 6.38671 1.21902 6.44338 1.19948 6.51764C1.17994 6.59189 1.18971 6.6642 1.22879 6.73454L2.14332 8.52842L2.15504 8.52842L2.15504 8.54015L2.21367 8.6574C2.2293 8.68084 2.24493 8.70039 2.26056 8.71602C2.2762 8.73165 2.29378 8.74533 2.31333 8.75705C2.33287 8.76878 2.35436 8.77855 2.37781 8.78637C2.44816 8.802 2.51851 8.79028 2.58885 8.75119L2.7061 8.68084L4.44136 7.567C4.50389 7.52792 4.54688 7.47125 4.57033 7.39699C4.59378 7.32273 4.58596 7.25043 4.54688 7.18008L4.48826 7.09801C4.44917 7.03548 4.39055 6.99835 4.31239 6.98663C4.23422 6.9749 4.16387 6.99249 4.10134 7.03939L3.08129 7.68425C3.13601 6.87915 3.37832 6.14049 3.80822 5.46828C4.23813 4.79606 4.80287 4.2665 5.50244 3.87958C6.20202 3.49267 6.95435 3.29921 7.75945 3.29921C8.39258 3.29921 8.99836 3.42427 9.57678 3.6744C10.1552 3.92453 10.6554 4.25868 11.0775 4.67686C11.4996 5.09504 11.8338 5.59334 12.08 6.17176C12.3262 6.75018 12.4493 7.35595 12.4493 7.98909C12.4493 8.84108 12.2402 9.62859 11.8221 10.3516C11.4039 11.0746 10.8333 11.6452 10.1102 12.0634C9.38723 12.4816 8.60363 12.6907 7.75945 12.6907C7.01688 12.6907 6.31731 12.5265 5.66073 12.1983C5.00414 11.87 4.45308 11.4088 4.00754 10.8147C3.96846 10.76 3.91765 10.7209 3.85512 10.6975C3.79259 10.674 3.7281 10.6662 3.66167 10.674C3.59523 10.6819 3.53465 10.7053 3.47993 10.7444C3.40177 10.8069 3.35487 10.889 3.33924 10.9906C3.3236 11.0922 3.34705 11.186 3.40958 11.272C3.92547 11.9599 4.56447 12.4933 5.32657 12.8724C6.08868 13.2515 6.89964 13.4411 7.75945 13.4411C9.12733 13.4411 10.3232 12.9877 11.3472 12.081C12.3321 11.2134 12.9261 10.1347 13.1294 8.84499C13.1763 8.55578 13.1997 8.27048 13.1997 7.98909Z",
                    fill: "#2951A3"
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx("span", { children: TRANSLATION[language].resend })
          ]
        }
      )
    ] })
  ] });
};
var FormOtp_default = memo(FormOtp);
var useCountdown = (initialSeconds) => {
  const [isStarted, setStarted] = useState(false);
  const [seconds, setSeconds] = useState(initialSeconds || 59);
  useEffect(() => {
    if (isStarted && seconds) {
      const secondsLeft = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1e3);
      return () => clearInterval(secondsLeft);
    }
  }, [isStarted, seconds]);
  const start = () => {
    setStarted(true);
  };
  const restart = () => {
    setSeconds(initialSeconds || 60);
  };
  const reset = () => {
    setStarted(false);
    setSeconds(initialSeconds || 60);
  };
  return [seconds, start, restart, reset];
};
var useCountdown_default = useCountdown;
var ModalOtp = ({
  title,
  children,
  phoneNumber,
  errorOtp,
  onSubmit,
  onChangePhoneNumber,
  onResend,
  onResetError,
  isLoading,
  language = "id",
  ...props
}) => {
  useEffect(() => {
    if (!props.open) {
      resetCountdown();
    } else {
      startCountdown();
    }
    if (!onResetError)
      return;
    onResetError();
  }, [props.open]);
  const [secondsLeft, startCountdown, _, resetCountdown] = useCountdown_default();
  return /* @__PURE__ */ jsx(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: "md:w-[420px]",
      title: title || TRANSLATION[language].phoneVerification,
      ...props,
      children: /* @__PURE__ */ jsx(
        FormOtp_default,
        {
          language,
          onSubmit: (otp) => {
            if (!onSubmit)
              return;
            onSubmit(otp);
          },
          errorOtp: errorOtp || false,
          onResetError: () => {
            if (!onResetError)
              return;
            onResetError();
          },
          phoneNumber: phoneNumber || "",
          resendTimeout: secondsLeft,
          onResend: () => {
            if (!onResend)
              return;
            onResend({
              phoneNumber: phoneNumber || "",
              callback: () => {
                resetCountdown();
                startCountdown();
              }
            });
          },
          onChangePhoneNumber: () => {
            if (onChangePhoneNumber) {
              onChangePhoneNumber();
            }
            resetCountdown();
          }
        }
      )
    }
  );
};
var PhoneList = ({
  value,
  onChange
}) => {
  const [isShowList, setShowList] = useState(false);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("p", { className: "flex items-center gap-x-1 cursor-pointer w-max mb-0", children: [
      /* @__PURE__ */ jsx("span", { children: value }),
      /* @__PURE__ */ jsx(
        "svg",
        {
          width: "13",
          height: "8",
          viewBox: "0 0 13 8",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M0.455739 1.71988L5.87774 6.92488C6.07124 7.11088 6.37724 7.11088 6.57074 6.92488L11.9927 1.71988C12.1922 1.52838 12.1987 1.21138 12.0072 1.01238C11.8157 0.813379 11.4987 0.806379 11.2997 0.997879L5.87774 6.20288H6.57074L1.14874 0.997879C0.949238 0.806379 0.632738 0.812879 0.441238 1.01238C0.249738 1.21188 0.256239 1.52838 0.455739 1.71988Z",
              fill: "#0D1A35"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "select",
      {
        className: "absolute top-0 left-0 opacity-0 h-full cursor-pointer",
        onChange: (e) => {
          onChange(e.target.value);
        },
        children: phoneNumbers.map((item) => {
          return /* @__PURE__ */ jsx("option", { value: item.value, children: item.label }, `${item.value}-${item.label}`);
        })
      }
    ),
    isShowList && /* @__PURE__ */ jsx("div", { className: "absolute top-full bg-white rounded-lg shadow-lg -left-3 overflow-auto max-h-36 no-scrollbar", children: /* @__PURE__ */ jsx("ul", { className: "list-none", children: phoneNumbers.map((item) => {
      return /* @__PURE__ */ jsx(
        "li",
        {
          className: "w-full whitespace-nowrap p-2 cursor-pointer hover:bg-[#F4F4F6]",
          onClick: () => {
            onChange(item.value);
            setShowList(false);
          },
          children: item.label
        },
        `${item.value}-${item.label}`
      );
    }) }) })
  ] });
};
var PhoneList_default = PhoneList;

// src/helper.ts
var cleanPrefixFromPhoneNumber = (prefix, phoneNumber) => {
  const phoneNumberWithoutZero = phoneNumber.startsWith("0") ? phoneNumber.slice(1) : phoneNumber;
  const cleanPrefix = prefix.startsWith("+") ? prefix.slice(1) : prefix;
  const cleanPhoneNumber = phoneNumberWithoutZero.startsWith("+") ? phoneNumberWithoutZero.slice(1) : phoneNumberWithoutZero;
  const hasPrefix = cleanPhoneNumber.startsWith(cleanPrefix);
  const processedNumber = hasPrefix ? cleanPhoneNumber.slice(cleanPrefix.length) : cleanPhoneNumber;
  return processedNumber;
};
var Loader = () => {
  return /* @__PURE__ */ jsx("span", { className: "animate-spin block mx-auto w-6 aspect-square rounded-full border-[3px] border-solid border-[#8da1d7] border-r-white" });
};
var Loader_default = Loader;
var ModalChangePhoneNumber = ({
  title,
  buttonText,
  initSelectedPrefix = "+62",
  initPhoneNumber = "",
  children,
  onSubmit,
  isLoading,
  language = "id",
  ...props
}) => {
  const [prefixPhoneNumber, setPrefixPhoneNumber] = useState(initSelectedPrefix);
  const [phoneNumber, setSelectedPhoneNumber] = useState(initPhoneNumber);
  useEffect(() => {
    if (initPhoneNumber === phoneNumber)
      return;
    setSelectedPhoneNumber(phoneNumber);
  }, [initPhoneNumber]);
  useEffect(() => {
    if (initSelectedPrefix === prefixPhoneNumber)
      return;
    setPrefixPhoneNumber(initSelectedPrefix);
  }, [initSelectedPrefix]);
  const onSubmitForm = () => {
    if (!onSubmit)
      return;
    const phoneNumberWithoutPrefix = cleanPrefixFromPhoneNumber(
      prefixPhoneNumber,
      phoneNumber || ""
    );
    onSubmit({
      phoneNumber: `${prefixPhoneNumber}${phoneNumberWithoutPrefix}`,
      prefixPhoneNumber
    });
  };
  return /* @__PURE__ */ jsxs(
    DialogWithHeader,
    {
      preventCloseOnBackground: true,
      className: "md:w-[420px]",
      title: title || TRANSLATION[language].changeNumber,
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            placeholder: TRANSLATION[language].placeHolderPhone,
            type: "text",
            className: "text-base !px-4 relative",
            containerClassName: "relative",
            required: true,
            prefix: /* @__PURE__ */ jsx(
              PhoneList_default,
              {
                value: prefixPhoneNumber,
                onChange: (value) => {
                  setPrefixPhoneNumber(value);
                }
              }
            ),
            value: phoneNumber,
            onChange: (e) => {
              const rawValue = e.target.value.replace(/\D/g, "");
              const numericValue = rawValue ?? "";
              setSelectedPhoneNumber(numericValue);
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: () => {
              onSubmitForm();
            },
            disabled: !phoneNumber || isLoading,
            className: "bg-primary cursor-pointer rounded-lg py-3 w-full font-bold text-center text-white border-none mt-10 disabled:bg-disabledGreyLight disabled:text-[#738492]",
            children: isLoading ? /* @__PURE__ */ jsx(Loader_default, {}) : buttonText || TRANSLATION[language].phoneVerification
          }
        )
      ]
    }
  );
};
var OTPContext = createContext({
  data: null,
  action: null
});
var OtpProvider = ({
  onVerifyOtp,
  onRequestOtp,
  type = EnumTypeOtp.Whatsapp,
  children
}) => {
  const [isShowOtp, setShowOTP] = useState(false);
  const [isShowChangePhoneNumber, setShowChangePhoneNumber] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [errorOtp, setErrorOtp] = useState(false);
  const [otpForm, setOtpForm] = useCookiesState(
    OTP_COOKIE_KEY,
    DEFAULT_OTP_COOKIE_VALUE
  );
  const onFinishEnquiryCallback = useRef(() => {
  });
  const onVerifyCallback = useRef();
  const requestOTP = async (phoneNumber) => {
    try {
      const data = await onRequestOtp({
        phoneNumber,
        cancelledRequestId: otpForm?.requestId,
        portalId: 1 /* rumah123 */,
        type
      });
      return {
        requestId: data.requestId
      };
    } catch (error) {
      const { extensions } = error || {};
      if (error?.errorInfo) {
        if (error?.errorInfo?.extensions?.code === INVALID_DESTINATION_NUMBER || error?.errorInfo?.message === "Invalid destination number") {
          return {
            requestId: ""
          };
        }
      }
      let shouldByPassOtp = false;
      try {
        if (!extensions?.code || extensions?.code === 5) {
          shouldByPassOtp = true;
        }
      } catch {
        shouldByPassOtp = true;
      }
      return {
        requestId: "",
        shouldByPassOtp
      };
    }
  };
  const verifyOTP = async (code) => {
    const verifier = onVerifyCallback.current ? onVerifyCallback.current : onVerifyOtp;
    return verifier({
      requestId: otpForm?.requestId || "",
      code,
      type
    }).catch((item) => item).then((item) => item);
  };
  const initOtp = async ({
    phoneNumber,
    name,
    onFinish,
    onVerify
  }) => {
    try {
      const data = await requestOTP(phoneNumber);
      if (!data.requestId) {
        return false;
      }
      setOtpForm((c) => {
        return {
          ...c,
          phoneNumber,
          name,
          requestId: data.requestId
        };
      });
      if (onFinish)
        onFinishEnquiryCallback.current = onFinish;
      if (onVerify)
        onVerifyCallback.current = onVerify;
      setShowOTP(true);
      return true;
    } catch (err) {
      return false;
    }
  };
  return /* @__PURE__ */ jsxs(
    OTPContext.Provider,
    {
      value: {
        data: otpForm,
        action: {
          initOtp
        }
      },
      children: [
        /* @__PURE__ */ jsxs(ReactPortalComponent, { children: [
          /* @__PURE__ */ jsx(
            ModalOtp,
            {
              isLoading,
              open: isShowOtp,
              onClose: () => {
                setShowOTP(false);
              },
              onChangePhoneNumber: () => {
                setShowOTP(false);
                setShowChangePhoneNumber(true);
              },
              phoneNumber: otpForm?.phoneNumber,
              errorOtp,
              onResetError: () => {
                setErrorOtp(false);
              },
              onSubmit: (code) => {
                setLoading(true);
                verifyOTP(code).then((value) => {
                  if (!value.isSuccess) {
                    setErrorOtp(true);
                    return;
                  }
                  if (value.isSuccess) {
                    setOtpForm((c) => {
                      return {
                        ...c,
                        requestId: "",
                        isVerified: true
                      };
                    });
                    setShowOTP(false);
                    if (onFinishEnquiryCallback.current) {
                      Promise.resolve(
                        onFinishEnquiryCallback.current(otpForm)
                      ).then(() => {
                        setLoading(false);
                      });
                    }
                    return;
                  }
                  setErrorOtp(true);
                  return;
                }).catch(() => {
                  setErrorOtp(true);
                }).then(() => {
                  setLoading(false);
                });
              },
              onResend: ({ phoneNumber, callback }) => {
                setLoading(true);
                requestOTP(phoneNumber).then((value) => {
                  if (value.requestId) {
                    setOtpForm((c) => {
                      return {
                        ...c,
                        requestId: value.requestId
                      };
                    });
                    callback();
                    return;
                  }
                }).catch(() => {
                  setLoading(false);
                });
              }
            }
          ),
          /* @__PURE__ */ jsx(
            ModalChangePhoneNumber,
            {
              isLoading,
              open: isShowChangePhoneNumber,
              onClose: () => {
                setShowChangePhoneNumber(false);
              },
              onSubmit: ({ phoneNumber, prefixPhoneNumber }) => {
                setLoading(true);
                requestOTP(phoneNumber).then((value) => {
                  if (value.requestId) {
                    setOtpForm((c) => {
                      return {
                        ...c,
                        requestId: value.requestId,
                        prefixPhoneNumber
                      };
                    });
                    setShowChangePhoneNumber(false);
                    setShowOTP(true);
                    return;
                  }
                }).catch(() => {
                  return;
                }).then(() => {
                  setLoading(false);
                  setOtpForm((c) => {
                    return {
                      ...c,
                      phoneNumber
                    };
                  });
                });
              },
              initPhoneNumber: otpForm?.phoneNumber
            },
            otpForm?.phoneNumber || ""
          )
        ] }),
        children
      ]
    }
  );
};
var useOtp = () => {
  return useContext(OTPContext);
};

export { OtpProvider, useOtp };
